import { Grid } from "@material-ui/core";
import { DATA_IDENTIFIER, ELEMENT } from "components/common/App/app-constant";
import { generateElementIdentifier } from "utils/ApplicationUtils";

interface ViewBasicDetailNameAndValueInterface {
  xsValue: any;
  classes: any;
  fieldTitle: any;
  fieldData: any;
}

export const ViewBasicDetailNameAndValue = (props: ViewBasicDetailNameAndValueInterface) => {
  const { classes, fieldTitle, fieldData, xsValue = 3 } = props;

  return (
    <Grid data-testid={generateElementIdentifier({ key: DATA_IDENTIFIER.VIEW_BASIC_DETAIL, customKey: fieldTitle, element: ELEMENT.GRID })} item xs={xsValue}>
      <div className={classes.fieldTitle}>{fieldTitle ?? "-"}</div>
      <div className={classes.fieldData}>{fieldData ?? "-"}</div>
    </Grid>
  );
};
